import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  NgZone,
  OnInit,
  Output,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import {
  BsDatepickerModule,
  BsDaterangepickerConfig,
} from 'ngx-bootstrap/datepicker';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { QuillModule } from 'ngx-quill';
import { environment } from 'src/environments/environment';
import {
  DEFAULT_TIPOS_OBRA,
  TipoObra,
} from '../home/listagem-obras/interface/tipos-obras.interface';
import { CommonLoaderComponent } from '../shared/components/common-loader/common-loader.component';
import { ConcluirTarefaComponent } from '../shared/components/modais-tarefas/concluir-tarefa/concluir-tarefa.component';
import { CriarTarefaComponent } from '../shared/components/modais-tarefas/criar-tarefa/criar-tarefa.component';
import { EditarTarefaCriadaComponent } from '../shared/components/modais-tarefas/editar-tarefa-criada/editar-tarefa-criada.component';
import { EnviarEmailComponent } from '../shared/components/modais-tarefas/enviar-email/enviar-email.component';
import { ExcluirTarefasComponent } from '../shared/components/modais-tarefas/excluir-tarefas/excluir-tarefas.component';
import { ModalNotificacaoPermissaoComponent } from '../shared/components/modais/modal-notificacao-permissao/modal-notificacao-permissao.component';
import { PaginacaoTarefasComponent } from '../shared/components/paginacao-tarefas/paginacao-tarefas.component';
import { TruncatePipe } from '../shared/pipes/truncate/truncate.pipe';
import { DashboardService } from '../shared/services/dashboard/dashboard.service';
import { AuthService } from '../shared/services/auth/auth.service';
import { ErrorHandleService } from '../shared/services/error-handle/error-handle.service';
import { ModulosBuscaService } from '../shared/components/filtros-busca/service/modulos-service/modulos.service';
import { Tarefas } from './interface/tasks.interface';
import { TarefasService } from './service/tarefas.service';
import { ObraNavegacaoService } from '../shared/services/obras-navegacao/obras-navegacao.service';

@Component({
  selector: 'app-tarefas',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatIconModule,
    ConcluirTarefaComponent,
    ExcluirTarefasComponent,
    PaginacaoTarefasComponent,
    QuillModule,
    BsDatepickerModule,
    EditarTarefaCriadaComponent,
    CommonLoaderComponent,
    TruncatePipe,
  ],
  templateUrl: './tarefas.component.html',
  styleUrls: ['./tarefas.component.scss'],
})
export class TarefasComponent implements OnInit {

  companyId: string = localStorage.getItem('companyID') || '';

  @Output() editar = new EventEmitter<any>();

  BASE_IMG_URL: string = environment.BASE_IMG_URL;
  config: Partial<BsDaterangepickerConfig> = {
    containerClass: 'bs-datepicker',
    rangeInputFormat: 'DD/MM/YYYY',
    showWeekNumbers: false,
    selectFromOtherMonth: true,
    isAnimated: true,
    displayMonths: 1,
  };

  mostrarResponsavel: boolean = false;
  mostrarTipoTarefa: boolean = false;
  mostrarTipoObra: boolean = false;
  exibirCalendario: boolean = false;
  modalRef?: BsModalRef;
  selecionarTodos: boolean = false;
  exibirModalCriarTarefa: boolean = false;
  mostrarModalConcluir: boolean = false;
  mostrarModalExcluir: boolean = false;
  mostrarModalEditar: boolean = false;
  carregandoTarefas: boolean = false;

  userName: string;
  userID: string;
  responsavel: any[] = [];
  acoes: any[] = [];
  tiposObra: TipoObra[] = DEFAULT_TIPOS_OBRA;
  tarefas: Tarefas[] = [];
  tarefasConcluidas: Tarefas[] = [];
  tarefasPendentes: Tarefas[] = [];
  tarefasAtrasadas: Tarefas[] = [];
  todasTarefas: Tarefas[] = [];
  tarefasExibidas: Tarefas[] = [];

  intervaloSelecionado: Date[] | null = null;
  filtroPeriodo: string = '';
  filtroResponsavel: string = 'Todos';
  filtroTipoObraSelecionados: number[] = [];
  filtroTipoTarefa = 'Todos';
  termoBusca = '';

  currentPage: number = 1;
  pageNumber: number = 1;
  pageSize: number = 50;
  totalObras: number;
  statusSelecionado: string = 'todas';

  dataInicio: string = '';
  dataFim: string = '';
  indiceObraAtual: number = 0;
  ordenacaoCampo: string = '';
  ordenacaoDirecao: 'asc' | 'desc' = 'asc';
  tarefaSelecionada: any = null;
  taskID: number | null = null;
  readonly statusTabs = [
    { key: 'todas', label: 'Todas as tarefas' },
    { key: 'atrasada', label: 'Atrasadas' },
    { key: 'pendente', label: 'Pendentes' },
    { key: 'concluida', label: 'Conclu\u00eddas' },
  ];

  filtrosAtivos: any = {
    responsavel: null,
    periodo: { inicio: '', fim: '' },
    tiposObra: [],
    tiposTarefa: 'Todos',
  };

  private modulos: { value: number; label: string }[] = [
    { value: 234, label: 'Imobiliário' },
    { value: 5, label: 'Industrial' },
    { value: 6, label: 'Edificações' },
    { value: 7, label: 'Infraestrutura' },
  ];

  idObra: number | null = null;
  idObraSelecionada: number | null = null;
  selectedWorkIds: number[] = [];
  selectedTaskIds: number[] = [];

  private resetarEstado(): void {
    this.modalRef = undefined;
    this.intervaloSelecionado = [];
    this.idObra = 0;
    this.idObraSelecionada = 0;
    this.taskID = 0;
    this.tarefaSelecionada = {};
  }

  constructor(
    private readonly modalService: BsModalService,
    private readonly _tarefaService: TarefasService,
    private readonly _dashboardService: DashboardService,
    private readonly _errorHandleService: ErrorHandleService,
    private readonly ngZone: NgZone,
    private router: Router,
    public bsModalRef: BsModalRef,
    private readonly cdRef: ChangeDetectorRef,
    private readonly _modalService: BsModalService,
    private readonly obraNavegacaoService: ObraNavegacaoService,
    private readonly authService: AuthService,
    private readonly modulosBuscaService: ModulosBuscaService,
  ) {
    this.getDadosUsuario();
    this.userID = localStorage.getItem('userId') || '';

    this.resetarEstado();
  }

  ngOnInit() {
    this.selectedWorkIds = [];
    this.popularResponsavelObra();
    this.popularAcao();
    this.carregarTarefas();
    this.showNotificationModal();
  }

  onDataRangeChange() {
    if (!this.intervaloSelecionado || this.intervaloSelecionado.length !== 2) {
      this.tarefas = [...this.todasTarefas];
      return;
    }

    const [inicio, fim] = this.intervaloSelecionado;

    if (inicio instanceof Date && fim instanceof Date) {
      this.dataInicio = inicio.toISOString();
      this.dataFim = fim.toISOString();

      this.carregandoTarefas = true;

      setTimeout(() => {
        this.tarefas = this.todasTarefas.filter((tarefa) => {
          const dataTarefa = new Date(tarefa.followUpDate);
          return dataTarefa >= inicio && dataTarefa <= fim;
        });

        this.carregandoTarefas = false;
      }, 400);
    } else {
      console.warn(
        'Os valores não são objetos Date válidos:',
        this.intervaloSelecionado,
      );
    }
  }

  onTermoBuscaChange(event?: KeyboardEvent): void {
    if (event && event.key !== 'Enter') {
      return;
    }

    this.currentPage = 1;
    this.carregandoTarefas = true;

    const body = {
      searchTerm: this.termoBusca,
      pagination: {
        page: this.currentPage,
        pageSize: this.pageSize,
        shortcuts: 10,
        ordenation: '',
      },
    };

    this._tarefaService.searchByWork(this.idObra || 0, body).subscribe(
      (response) => {
        if (response.success) {
          this.tarefas = response.data.records || [];
          this.totalObras = response.data.recordsCount || 0;
          this.tarefasExibidas = [...this.tarefas];
        } else {
          console.error('Erro ao buscar tarefas:', response.message);
          this.tarefas = [];
        }
        this.carregandoTarefas = false;
      },
      (error) => {
        console.error('Erro ao buscar tarefas:', error);
        this.tarefas = [];
        this.carregandoTarefas = false;
      },
    );
  }

  abrirModal() {
    this.modalRef = this.modalService.show(CriarTarefaComponent);

    const componente = this.modalRef.content as CriarTarefaComponent;

    componente.tarefaCriada.subscribe(() => {
      this.modalRef?.hide();
      this.carregarTarefas();
    });
  }

  fecharModal() {
    this.modalRef?.hide();
  }

  abrirModalEmail() {
    this.modalService.show(EnviarEmailComponent);
  }

  criarTarefa() {
    this.exibirModalCriarTarefa = false;
    this.carregarTarefas();
  }

  abrirModalConcluirTarefa(tarefa: any) {
    const taskID = tarefa?.raw?.taskID || tarefa?.taskID;
    this.taskID = taskID;
    this.mostrarModalConcluir = true;
  }

  fecharModalConcluirTarefa(confirmado: boolean): void {
    this.mostrarModalConcluir = false;
    this.taskID = null;
    if (confirmado) {
      this.carregarTarefas();
    }
  }

  onTarefaConcluida() {
    this.fecharModalConcluirTarefa(true);
  }

  abrirModalExcluir(taskID?: number): void {
    if (typeof taskID === 'number') {
      this.taskID = taskID;
      this.selectedTaskIds = [];
    } else {
      // Seleção em massa: pega todos os IDs das tarefas selecionadas
      this.selectedTaskIds = this.tarefas
        .filter((t) => t.selecionada)
        .map((t) => t.taskID);
      this.taskID = null;
    }
    this.mostrarModalExcluir = true;
  }

  fecharModalExcluir(confirmado: boolean): void {
    this.mostrarModalExcluir = false;

    if (confirmado) {
      this.carregarTarefas();
    }
  }

  abrirModalEditarTarefa(tarefa: any): void {
    this.tarefaSelecionada = { ...tarefa, id: tarefa.id ?? tarefa.taskID };

    this.mostrarModalEditar = true;
  }
  fecharModalEditarTarefa(): void {
    this.mostrarModalEditar = false;
    if (this.tarefaSelecionada?.editada) {
      this.carregarTarefas();
    }
  }

  aplicarFiltros(): void {
    this.carregarTarefas();
  }

  onResponsavelChange() {
    this.filtrosAtivos.responsavel =
      this.filtroResponsavel !== 'Todos'
        ? Number(this.filtroResponsavel)
        : null;
    this.mostrarResponsavel = false;
    this.carregarTarefas();
  }

  onTipoTarefaChange() {
    const selectedTaskType = this.acoes.find(
      (acao) => acao.description === this.filtroTipoTarefa,
    );
    this.filtrosAtivos.tiposTarefa = selectedTaskType
      ? selectedTaskType.id
      : 'Todos';
    this.mostrarTipoTarefa = false;
    this.carregarTarefas();
  }

  onPeriodoChange() {
    if (this.intervaloSelecionado && this.intervaloSelecionado.length === 2) {
      const [inicio, fim] = this.intervaloSelecionado;

      if (inicio instanceof Date && fim instanceof Date) {
        this.filtrosAtivos.periodo = {
          inicio: inicio.toISOString().split('T')[0],
          fim: fim.toISOString().split('T')[0],
        };

        this.carregarTarefas();
      } else {
        console.warn(
          'Os valores de início e fim não são objetos Date válidos:',
          this.intervaloSelecionado,
        );
      }
    } else {
      this.filtrosAtivos.periodo = { inicio: '', fim: '' };
    }
  }

  getStatusClass(status: string): string {
    const normalized = status
      ?.trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

    switch (normalized) {
      case 'atrasada':
        return 'status-atrasada';
      case 'pendente':
        return 'status-pendente';
      case 'concluida':
        return 'status-concluida';
      case 'excluida':
        return 'status-excluida';
      default:
        return '';
    }
  }

  get totalPages(): number {
    return this.totalPagesValue;
  }

  totalPagesValue: number = 0;

  mudarPagina(novaPagina: number): void {
    this.currentPage = novaPagina;
    this.pageNumber = novaPagina;
    this.carregarTarefas();
  }
  get exibirPaginacao(): boolean {
    return this.tarefas.length >= 25;
  }

  get tarefasFiltradas(): any[] {
    return this.tarefas.filter(
      (t) =>
        this.filtroResponsavel === 'Todos' ||
        t.responsibleID === Number(this.filtroResponsavel),
    );
  }

  get tarefasPaginadas() {
    const start = (this.currentPage - 1) * this.pageSize;
    return this.tarefasFiltradas.slice(start, start + this.pageSize);
  }

  mudarAba(status: string) {
    this.statusSelecionado = status;
    this.currentPage = 1;

    if (status === 'pendente' && this.tarefasPendentes.length > 0) {
      this.carregandoTarefas = false;
      this.tarefas = [...this.tarefasPendentes];
    } else {
      this.carregandoTarefas = true;
      this.carregarTarefas();
    }
  }

  mapStatusToID(status: string): number {
    switch (status) {
      case 'atrasada':
        return 1;
      case 'pendente':
        return 2;
      case 'concluida':
        return 3;
      case 'excluida':
        return 4;
      default:
        return 0;
    }
  }

  private construirBodyRequisicao(): any {
    return {
      pagination: {
        page: this.pageNumber,
        pageSize: this.pageSize,
        shortcuts: 10,
        ordenation: '',
      },
      statusID: this.mapStatusToID(this.statusSelecionado),
      ...(this.filtrosAtivos.responsavel && {
        responsibleID: this.filtrosAtivos.responsavel,
      }),
      ...(this.filtrosAtivos.periodo.inicio &&
        this.filtrosAtivos.periodo.fim && {
          dateBegin: this.filtrosAtivos.periodo.inicio.split('T')[0],
          dateEnd: this.filtrosAtivos.periodo.fim.split('T')[0],
        }),
      ...(this.filtrosAtivos.tiposObra.length > 0 && {
        workTypeID: this.filtrosAtivos.tiposObra.join(','),
      }),
      ...(this.filtrosAtivos.tiposTarefa !== 'Todos' && {
        taskTypeID: this.filtrosAtivos.tiposTarefa,
      }),
    };
  }

  private processarResposta(response: any): void {
    const data = response.data || {};
    const records = data.records || [];

    this.tarefas = records.map((t) => ({
      ...t,
      statusDescription: t.statusDescription
        ?.trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, ''),
    }));

    this.selectedWorkIds = [...new Set(this.tarefas.map((t) => t.workID))];

    this.pageNumber = data.page || 1;
    this.pageSize = data.pageSize || 25;
    this.totalPagesValue = Math.ceil((data.recordsCount || 0) / this.pageSize);
    this.totalObras = data.recordsCount || 0;
  }

  carregarTarefas(): void {
    this.carregandoTarefas = true;

    const body = this.construirBodyRequisicao();

    this._tarefaService.listTaks(body).subscribe({
      next: (response) => {
        if (response.success) {
          this.processarResposta(response);
        } else {
          console.error('Erro ao carregar tarefas:', response.message);
          this.tarefas = [];
        }
        this.carregandoTarefas = false;
      },
      error: (err) => {
        console.error('Erro ao carregar tarefas:', err);
        this.tarefas = [];
        this.carregandoTarefas = false;
      },
    });
  }

  get tipoObraSelecionado(): number {
    return this.filtroTipoObraSelecionados.length === 1
      ? this.filtroTipoObraSelecionados[0]
      : null;
  }

  set tipoObraSelecionado(value: number) {
    this.filtroTipoObraSelecionados = value ? [value] : [];
  }

  onTipoObraChange(): void {
    this.mostrarTipoObra = false;
    this.carregarTarefas();
  }

  onTipoObraToggle(tipoId: number, event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const isChecked = inputElement.checked;

    if (isChecked) {
      if (!this.filtroTipoObraSelecionados.includes(tipoId)) {
        this.filtroTipoObraSelecionados.push(tipoId);
      }
    } else {
      this.filtroTipoObraSelecionados = this.filtroTipoObraSelecionados.filter(
        (id) => id !== tipoId,
      );
    }

    this.filtrosAtivos.tiposObra = [...this.filtroTipoObraSelecionados];

    this.mostrarTipoObra = false;
  }

  getFilteredArrayLength(): number {
    switch (this.statusSelecionado) {
      case 'pendente':
        return this.tarefasPendentes.length;
      case 'concluida':
        return this.tarefasConcluidas.length;
      case 'atrasada':
        return this.tarefasAtrasadas.length;
      case 'todas':
      default:
        return this.todasTarefas.length;
    }
  }

  limparResponsavel() {
    this.filtrosAtivos.responsavel = null;
    this.filtroResponsavel = 'Todos';
    this.carregarTarefas();
  }

  limparPeriodo() {
    this.filtrosAtivos.periodo = { inicio: '', fim: '' };
    this.intervaloSelecionado = [];
    this.carregarTarefas();
  }

  limparTiposObra() {
    this.filtrosAtivos.tiposObra = [];
    this.filtroTipoObraSelecionados = [];
    this.carregarTarefas();
  }

  limparTipoTarefa() {
    this.filtrosAtivos.tiposTarefa = 'Todos';
    this.filtroTipoTarefa = 'Todos';
    this.carregarTarefas();
  }

  limparBusca() {
    this.termoBusca = '';
    this.onTermoBuscaChange();
    this.carregarTarefas();
  }

  popularResponsavelObra(): void {
    this._tarefaService.listResponsables().subscribe(
      (response) => {
        this.responsavel = response.data.sort((a, b) =>
          a.name.localeCompare(b.name),
        );
      },
      (error) => {
        console.error('Erro ao buscar ações:', error);
      },
    );
  }

  popularAcao(): void {
    this._tarefaService.listActions().subscribe(
      (response) => {
        this.acoes = response.data.sort((a, b) =>
          a.description.localeCompare(b.description),
        );
      },
      (error) => {
        console.error('Erro ao buscar ações:', error);
      },
    );
  }

  private fecharTodosDropdowns(): void {
    this.mostrarResponsavel = false;
    this.mostrarTipoTarefa = false;
    this.mostrarTipoObra = false;
  }

  toggleResponsavel(): void {
    if (this.mostrarResponsavel) {
      this.fecharTodosDropdowns();
    } else {
      this.fecharTodosDropdowns();
      this.mostrarResponsavel = true;
    }
  }

  toggleTipoTarefa(): void {
    if (this.mostrarTipoTarefa) {
      this.fecharTodosDropdowns();
    } else {
      this.fecharTodosDropdowns();
      this.mostrarTipoTarefa = true;
    }
  }

  toggleTipoObra(): void {
    if (this.mostrarTipoObra) {
      this.fecharTodosDropdowns();
    } else {
      this.fecharTodosDropdowns();
      this.mostrarTipoObra = true;
    }
  }

  getDadosUsuario() {
    let companyId = localStorage.getItem('companyID'),
      restrictionKey = localStorage.getItem('restrictionKey'),
      usuarioId = localStorage.getItem('userId');

    this._dashboardService
      .dadosUsuario(companyId, restrictionKey, usuarioId)
      .subscribe(
        (response) => {
          if (response.success) {
            this.userName = response.data.name;
          } else {
            this._errorHandleService.throwConsoleError(response);
          }
        },
        (error) => {
          this._errorHandleService.redirectToNotFound(error);
        },
      );
  }

  get nomeResponsavelSelecionado(): string {
    if (this.filtroResponsavel === 'Todos') {
      return 'Todos os responsáveis';
    }
    const responsavel = this.responsavel.find(
      (r) => r.id === Number(this.filtroResponsavel),
    );
    return responsavel ? responsavel.name : this.filtroResponsavel;
  }

  get hasSelectedTasks(): boolean {
    return this.tarefas.some((t) => t.selecionada);
  }

  ordenarPorStatus(): void {
    if (this.ordenacaoCampo === 'statusDescription') {
      this.ordenacaoDirecao = this.ordenacaoDirecao === 'asc' ? 'desc' : 'asc';
    } else {
      this.ordenacaoCampo = 'statusDescription';
      this.ordenacaoDirecao = 'asc';
    }

    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;

    this.tarefas = [
      ...this.tarefas.slice(0, start),
      ...this.tarefas.slice(start, end).sort((a, b) => {
        const statusA = a.statusDescription.toLowerCase();
        const statusB = b.statusDescription.toLowerCase();

        if (statusA < statusB) {
          return this.ordenacaoDirecao === 'asc' ? -1 : 1;
        }
        if (statusA > statusB) {
          return this.ordenacaoDirecao === 'asc' ? 1 : -1;
        }
        return 0;
      }),
      ...this.tarefas.slice(end),
    ];
  }

  ordenarPorCampo(campo: string): void {
    if (this.ordenacaoCampo === campo) {
      this.ordenacaoDirecao = this.ordenacaoDirecao === 'asc' ? 'desc' : 'asc';
    } else {
      this.ordenacaoCampo = campo;
      this.ordenacaoDirecao = 'asc';
    }

    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;

    this.tarefas = [
      ...this.tarefas.slice(0, start),
      ...this.tarefas.slice(start, end).sort((a, b) => {
        const valorA = a[campo]?.toString().toLowerCase() || '';
        const valorB = b[campo]?.toString().toLowerCase() || '';

        if (valorA < valorB) {
          return this.ordenacaoDirecao === 'asc' ? -1 : 1;
        }
        if (valorA > valorB) {
          return this.ordenacaoDirecao === 'asc' ? 1 : -1;
        }
        return 0;
      }),
      ...this.tarefas.slice(end),
    ];
  }

  chamarBuscaApto(idEmpresa: number): void {
    const isParceiroValue = '0';
    const sessionUserID = this.userID;
    const parametros = `&tipoLink=empresa&idEmpresa=${idEmpresa}&IsParceiro=${isParceiroValue}&chrParceiro=&sessionUserID=${sessionUserID}`;

    const form = document.forms['frmFormulario'];

    let removedInputs: HTMLInputElement[] = [];

    if (form) {
      const inputs = form.querySelectorAll(
        'input[name="1"], input[name="2"], input[name="35"]',
      );

      inputs.forEach((input: HTMLInputElement) => {
        removedInputs.push(input);
        input.remove();
      });
    }

    if (typeof (window as any).efetuarBusca_Apto === 'function') {
      this.ngZone.runOutsideAngular(() => {
        (window as any).efetuarBusca_Apto(
          'frmFormulario',
          '',
          'false',
          '_Lista',
          parametros,
        );

        const formAgain = document.forms['frmFormulario'];
        removedInputs.forEach((input) => {
          if (formAgain) {
            formAgain.appendChild(input);
          }
        });
      });
    } else {
      console.error(
        'A função efetuarBusca_Apto não está disponível no escopo global.',
      );
    }
  }

  abrirFichaDaObra(workID: number, tarefa: any): void {
    if (!workID) {
      console.error('workID inválido.');
      return;
    }

    const nomeModulo = this.getRotaModulo(tarefa);
    if (!nomeModulo) {
      console.error('Módulo não encontrado para a tarefa:', tarefa);
      return;
    }

    const ids = [...new Set(this.tarefas.map((t) => t.workID))];
    if (!ids.includes(workID)) ids.push(workID);

    this.obraNavegacaoService.setObraIds(ids, nomeModulo);
    this.router.navigate(['/buscas', nomeModulo, 'detalhes', workID]);
  }

  abrirObraNova(t: any): void {
    this.abrirFichaDaObra(t.workID, t);
  }

  abrirObra(t: any): void {
    this.abrirFichaDaObra(t.workID, t);
  }

  private getRotaModulo(tarefa: any): string | null {
    const moduloId = Number(tarefa?.moduleID ?? tarefa?.moduleId ?? 0);
    if ([2, 3, 4, 234].includes(moduloId)) {
      return 'imobiliario';
    }
    if (moduloId) {
      return this.modulosBuscaService.getRotaById(moduloId);
    }

    const normalizar = (valor: string): string =>
      (valor || '')
        .trim()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();
    const workType = normalizar(tarefa?.workType);
    const modulo = this.modulos.find(
      (item) => normalizar(item.label) === workType,
    );

    return modulo ? this.modulosBuscaService.getRotaById(modulo.value) : null;
  }

  selecionarTodosTarefas(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const isChecked = inputElement.checked;

    this.tarefas.forEach((tarefa) => {
      tarefa.selecionada = isChecked;
    });

    if (isChecked) {
      this.selectedTaskIds = this.tarefas.map((tarefa) => tarefa.taskID);
      this.selectedWorkIds = this.tarefas.map((tarefa) => tarefa.workID);
    } else {
      console.log('Nenhuma tarefa selecionada.');
    }
  }

  toggleSelecionarTodos(): void {
    this.selecionarTodos = !this.selecionarTodos;
    this.tarefasPaginadas.forEach((task) => {
      task.selecionada = this.selecionarTodos;
    });
  }

  isAllSelected(): boolean {
    return this.tarefas.every((tarefa) => tarefa.selecionada);
  }

  onTarefaSelecionada(tarefa: Tarefas): void {
    // console.log('Tarefa selecionada:', tarefa.taskID);
  }

  ngOnChanges() {
    if (this.idObraSelecionada) {
      this.indiceObraAtual = this.tarefas.findIndex(
        (tarefa) => tarefa.workID === this.idObraSelecionada,
      );
    }
  }


  getTarefaPorWorkID(): Tarefas | undefined {
    return this.tarefas.find(
      (tarefa) => tarefa.workID === this.idObraSelecionada,
    );
  }

  editarTarefa(tarefa: any) {
    this.editar.emit({
      ...tarefa,
      descricao: tarefa.descricao,
      data: tarefa.data,
      hora: tarefa.horaInput,
      raw: tarefa.raw,
    });
  }

  fecharModalCriarTarefa() {
    this.exibirModalCriarTarefa = false;
  }

  trackByTaskId(index: number, tarefa: Tarefas): number {
    return tarefa.taskID;
  }

  showNotificationModal(): void {
    if (!ModalNotificacaoPermissaoComponent.shouldShowModal(this.authService)) {
      return;
    }

    this.bsModalRef = this._modalService.show(
      ModalNotificacaoPermissaoComponent,
      {
        class: 'modal-dialog-centered modal-notification-permission',
        keyboard: false,
        ignoreBackdropClick: true,
        backdrop: true,
      },
    );
  }

  getTagClass(val: string): string {
    if (!val) return '';
    return val
      .toLowerCase()
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '')
      .replace(/\s/g, '');
  }

  tipoObraColors: { [key: string]: string } = {
    imobiliario: '#ee7b0b',
    edificacoes: '#495057',
    infraestrutura: '#6b6864',
    industrial: '#b4ada1',
  };

  getTipoObraColor(tipo: string): string {
    if (!tipo) return '#888';
    const key = tipo
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
    return this.tipoObraColors[key] || '#888';
  }

  onEmpresaClick(row: any) {
    const termo = row.companyName || row.empresa || row.name || '';
    this.router.navigate(['/busca/empresa'], { queryParams: { termo } });
  }

}
